export default "__VITE_ASSET__C0Js$v8g__"